import { useQuery } from '@tanstack/react-query';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { OrderTemplateListItem } from '../api/types';

const useOrderTemplatesList = (
  billingAccountId: number | null,
  orderType: 'GIG' | 'LTA' | null,
) => {
  const enabled = billingAccountId != null;
  const query = useQuery<OrderTemplateListItem[]>({
    queryKey: enabled
      ? orderV2QueryKeys.orderTemplates(billingAccountId, orderType)
      : ['orders_v2', 'order_templates', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listOrderTemplates(billingAccountId as number, orderType || undefined)
        .then((result) => result || []),
    enabled,
  });

  return { templates: query.data ?? [] };
};

export default useOrderTemplatesList;
